module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAASFBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8uTG0A7AAAAF3RSTlMA+TCQBpE4LAvXlOTUmMq7jirYvUQWFRhNt14AAAB7SURBVBjTZY9bDsMgDAS9OIAhJE362vvftETQVoL5sTSyvbZcnEcC0nFKZ8nsbNbEjfDBLHjwsVwmc3Wt2a3MtUSgiq6AKKL08sNTRRLD3wQmEbBua1E1hRiMEdNUmTfP6eOF2/cLdWZOQZb38Gnh3tqj3oGiUV77U2Y+bTgHPQVIzuUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_narrow_hover.png
// module id = NBb4
// module chunks = 9